import dayjs from 'dayjs';

const parseDate = (
  dateString: string | undefined,
  format: (
    date: Date,
    year: string,
    month: string,
    day: string,
    hours: string,
    minutes: string,
    seconds: string
  ) => string
): string => {
  if (dateString == undefined) return '';
  const date = new Date(dateString);
  const year = date.getFullYear().toString();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');
  return format(date, year, month, day, hours, minutes, seconds);
};

/**
 *
 * @param dateString expected format: YYYY-MM-DDThh:mm:ss.fff
 * @returns formatted date: YYYY-MM-DD
 */
export const formatDate = (dateString: string | undefined) => {
  return parseDate(dateString, (_, year, month, day) => `${year}-${month}-${day}`);
};

/**
 *
 * @param dateString expected format: YYYY-MM-DDThh:mm:ss.fff
 * @returns formatted date with time: YYYY-MM-DD kl hh:mm
 */
export const formatDateWithTime = (dateString: string | undefined) => {
  return parseDate(
    dateString,
    (_, year, month, day, hours, minutes) => `${year}-${month}-${day} kl ${hours}:${minutes}`
  );
};

export const parseDateString = (originalValue: string) => {
  const parsedDate = dayjs(originalValue);
  return parsedDate.isValid() ? parsedDate.toDate() : null;
};
